import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as FiltrosCalendarioUsoPesquisadorActions } from "../ducks/filtrosCalendarioUsoPesquisador";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as LoadingActions } from "../ducks/loading";

export function* getValuesPesquisador() {
  try {
    yield put(LoadingActions.setLoading());
    const { month, year } = yield select(
      state => state.filtrosCalendarioUsoPesquisador
    );
    const date = `01/${month.split("-", 1)[0]}/${year.split("-", 1)[0]}`;
    const { data } = yield call(api.get, `/pesquisador/calendar?date=${date}`);
    yield put(
      FiltrosCalendarioUsoPesquisadorActions.getValuesPesquisadorSuccess(data)
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getPropostasDiarios({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { date_type, value, users, stores, regions } = yield select(
      state => state.filtrosCalendarioUsoPesquisador
    );
    const filter = {
      date_type: date_type.split("-", 1)[0],
      date: payload.date,
      value: value.split("-", 1)[0],
      users: users.map(user => user.split("-", 1)[0]),
      stores: stores.map(store => store.split("-", 1)[0]),
      regions: regions.map(region => region.split("-", 1)[0])
    };
    const { data } = yield call(api.post, `/reports/daily-values/data`, filter);
    yield put(
      FiltrosCalendarioUsoPesquisadorActions.getPropostasDiariosSuccess(
        data.data,
        data.columns_settings
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/filtrosCalendarioUsoPesquisador.js